enum VEHICLE_TYPE {
    VAN = 'VAN'
}

export default VEHICLE_TYPE;
